export default "__VITE_ASSET__An5N$2Lz__"